import { first } from 'lodash';

export default function filterAvailableLocations(locations, segments, selectedLocations) {
  // If we didn't select a location yet just return all locations
  if (selectedLocations.length === 0) {
    return locations;
  }

  // We only need to loop over segments connected to this location
  const existingSegments = segments.filter(segment => segment.from.id === first(selectedLocations));

  // Filter out all available locations
  if (selectedLocations.length === 1) {
    return locations.reduce((acc, curr) => {
      // if it is not in the to object of any segment, keep it in the array
      if (!existingSegments.find(segment => segment.to.id === curr.id)) {
        return [...acc, curr];
      }
      return acc;
    }, []);
  }

  // If you already selection two locations (in which case this function shouldn't even be called) just return the two selected items
  if (selectedLocations.length === 2) {
    return locations.filter(location => selectedLocations.includes(location.id));
  }
  return locations;
}



// WEBPACK FOOTER //
// ./src/helpers/filterAvailableLocations.js